var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.noImage)?_c('div',{staticClass:"text-center padding_top_10 padding_bottom_5"},[_c('img',{staticClass:"logo-frame",attrs:{"src":_vm.practiceDetails.Url}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"padding_bottom_20"},[_c('ClientPracticeAddress')],1),_vm._v(" "),_c('NavigationLink')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5247726","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBar.vue
// module id = null
// module chunks = 